import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import { useSessaoAtual } from '../../../services/app/providers';
import { isEmpty } from 'lodash';
import { useCallback, useEffect } from 'react';
import { KdsStorageKeys, useKdsStorage, useKdsToken, useToastSaurus } from '../../../services/app';


export const ExpiredTokenRoute: React.FC<RouteProps> = ({
  children,
  ...otherProps
}) => {
  const { usuario, termosDeUsoAtivo, carregando: carregandoSessaoAtual, validaUsuarioConectado, refreshUser } = useSessaoAtual();
  const { getEmpresaAtual, isTokenExpired } = useKdsToken();
  const { showToast } = useToastSaurus();
  const { delRegistro } = useKdsStorage();
  const { getRegistro } = useKdsStorage();
  const { pathname } = useLocation()

  const modulo = getRegistro(KdsStorageKeys.SelecaoModulo, false)

  const carregando = carregandoSessaoAtual

  useEffect(() => {
    if (isTokenExpired(usuario)) {
      if (validaUsuarioConectado()) {
        refreshUser(usuario!.originalToken)
      }
    }
  }, [isTokenExpired, refreshUser, usuario, validaUsuarioConectado])

  const retRoute = useCallback(() => {

    if (isTokenExpired(usuario) && !validaUsuarioConectado()) {
      showToast(
        'error',
        `Sua sessão expirou. Realize o login novamente para continuar. (401) `,
      );
      delRegistro(KdsStorageKeys.Token, false);
      return <Redirect to={`/login/expirou${!isEmpty(pathname) && pathname.includes('pedidos-para-entrega') ? `?redirect=${btoa(pathname)}` : ''}`} />;
    }

    return carregando ? (
      children
    ) : isEmpty(usuario) ? (
      <Redirect to="/login/expirou" />
    ) : !termosDeUsoAtivo() ? (
      <Redirect to="/termos-de-uso" />
    ) : !getEmpresaAtual() ? (
      <Redirect to="/selecionar-empresa" />
    ) : isEmpty(modulo) ? (
      <Redirect to="/selecionar-modulo" />
    ) : (
      children
    );
  }, [isTokenExpired, usuario, validaUsuarioConectado, carregando, children, termosDeUsoAtivo, getEmpresaAtual, modulo, showToast, delRegistro, pathname]);
  return <Route {...otherProps}>{retRoute()}</Route>;
};
